import { IComponentOptions } from "angular";
import { ChangeJournalViewComponentController } from "./controller";

export const changeJournalViewComponentOptions: IComponentOptions = {
  controller: ChangeJournalViewComponentController,
  controllerAs: "viewComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    objects: "<",
  },
};
